/**
 * @prettier
 */

import 'static'
import { lodashModules } from 'utils/lodash_modules'

window._ = lodashModules
